import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CopyContactRoleModalBase from 'components/contacts/copy_contact_role_modal';
import { addContactRoles } from 'components/project/actions';

export class CopyContactRoleModal extends React.Component {
  static propTypes = {
    addContactRoles: PropTypes.func.isRequired,
    databaseContactRoles: PropTypes.arrayOf(PropTypes.shape({
      contact: PropTypes.shape({
        email: PropTypes.string,
        name: PropTypes.string,
        phoneFormatted: PropTypes.string,
        referralSourceLabel: PropTypes.string
      }).isRequired,
      id: PropTypes.number,
      relationshipLabel: PropTypes.string,
    })),
    projectId: PropTypes.number.isRequired,
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
  }

  state = {
    saving: false
  }

  copyFromContactRoles = (contactRoles) => {
    this.setState({ saving: true });

    const contactRoleData = contactRoles.map(contactRole => ({
      contactId: contactRole.contact.id,
      contactType: contactRole.contact.contactType,
      relationship: contactRole.relationship
    }));

    this.props.addContactRoles(
      this.props.projectId,
      contactRoleData
    )
      .then(this.props.onClose)
      .then(() => this.setState({ saving: false }));
  }

  render() {
    return (
      <CopyContactRoleModalBase
        copyFromString="Database Property"
        projectContactRoles={this.props.databaseContactRoles}
        saving={this.state.saving}
        show={this.props.show}
        onAddContactRoles={this.copyFromContactRoles}
        onClose={this.props.onClose}
      />
    );
  }
}

const mapStateToProps = state => ({
  databaseContactRoles: state.project.databaseContactRoles,
  projectId: state.project.id
});

const mapDispatchToProps = {
  addContactRoles
};

export default connect(mapStateToProps, mapDispatchToProps)(CopyContactRoleModal);
